<template>
  <div :style="themeStyle">
    <!-- <header-profile></header-profile> -->
    <v-container class="pa-5">
      <v-card class="mx-auto pa-5 mb-5" max-width="400">
        <v-card-title>
          <v-avatar size="54px">
            <img v-if="this.items.logo" alt="Avatar" :src="this.items.logo" />
            <img v-else alt="Avatar" src="@/assets/user.png" />
          </v-avatar>
          <p class="text-h6 font-weight-light ml-4 mb-0" :style="$isTargetshop ? 'font-size: 12px !important' : ''">{{ this.items.name }}</p>
        </v-card-title>

        <v-card-text  style="margin-bottom: 20px;">
          <div style="display: flex;">
            <p class="mb-0" style="color: #871b12;margin-right:10px;">{{ $t("message.address") }} :</p>
            <p class="mb-0" style="flex: 1"> {{this.items.detailAddress +' '+ this.items.Address }}</p>
          </div>
          <div style="display: flex; margin-bottom:20px;">
            <p class="mb-0" style="color: #871b12;margin-right:7px">{{ $t("message.tel") }} :</p>
            <!-- <p class="mb-0">{{ this.items.contactTel }}</p> -->
            <a class="mb-0" :href="'tel:' + this.items.contactTel">{{ this.items.contactTel }}</a>
          </div>
                  <v-divider  class="mb-1"></v-divider>
            <!-- <menu-item icon="store" title="สาขาทั้งหมดของเรา" link="/Mybranch"></menu-item> -->
            <div style="display: flex;justify-content:space-between;" @click="isShow = !isShow">
                  <div style="padding-top: 5px;padding-left: 0px;font-size: 15px;line-height: 24px;color: #323232;">
                    {{ $t("message.allBranch") }}
                  </div>
                  <v-icon  v-if="isShow" style="padding-right: 10px;" size="30px">
                      mdi-menu-up-outline
                  </v-icon>
                   <v-icon v-if="isShow === false" style="padding-right: 10px;" size="30px">
                      mdi-menu-down-outline
                  </v-icon>
            </div>
            <div v-if="isShow" :class="(isShow === true) ? 'animation' : 'test'">
                <div v-for="(item,i) in items2" :key="i">
                  <p style="font-weight: 800;font-size: 15px;line-height: 24px;color: #323232;margin-bottom:10px;" class="bold">{{item.masBranchName}}</p>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-alarm
                  </v-icon> {{item.timeOC}}
                </div>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-phone
                  </v-icon> <a class="mb-0" :href="'tel:' + item.tel">{{item.tel}}</a>
                </div>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-map-marker
                  </v-icon>
                  <a :href="item.map">{{ $t("message.map") }}</a>
                </div>
                <v-divider></v-divider>
                </div>
              </div>
            <v-divider class="mt-2"></v-divider>

          <!-- <p class="mb-2" style="color: #871b12">สาขาทั้งหมด </p>
          <v-card class="mb-2" style="padding:10px;" v-for="(item,i) in items2" :key="i">
          <p class="mb-0">- {{item.masBranchName}}</p>
          <p class="mb-0">เบอร์ติดต่อ : {{item.tel}}</p>
          <div style="display: flex">
          <p class="mb-0">แผนที่ :</p>
          <a :href="item.map">Click <v-icon size="18px" color="#1778F2">
            mdi-cursor-default-click
          </v-icon></a>
          </div>
          </v-card> -->
        </v-card-text>
        <div style="display: flex;margin-bottom: 10px">
           <p class="mb-0" style="color: #871b12">Website :</p>
           <a :href="this.items.WebsiteShop" class="mb-0">{{this.items.WebsiteShop}}</a>
        </div>
       <div style="display: flex">
        <div style="display: flex"  v-if="this.items.FacebookShop">
          <a :href="this.items.FacebookShop" class="mb-0" style="margin-right: 5px; margin-left: 5px;"> <v-icon size="32px">
            mdi-facebook
          </v-icon></a>
        </div>
        <div style="display: flex" v-if="this.items.InstagramShop">
          <a :href="this.items.InstagramShop" class="mb-0" style="margin-right: 5px; margin-left: 5px;">
            <v-icon size="32px" >
            mdi-instagram
          </v-icon>
          </a>
        </div>
        <div style="display: flex" v-if="this.items.TwitterShop">
          <a :href="this.items.TwitterShop" style="margin-right: 5px; margin-left: 5px;">
              <v-icon size="32px">
            mdi-twitter
          </v-icon>
          </a>
        </div>
         <div style="display: flex" v-if="this.items.YoutuberShop">
          <a :href="this.items.YoutuberShop" style="margin-right: 5px; margin-left: 5px;">
              <v-icon size="32px" >
            mdi-youtube
          </v-icon>
          </a>
        </div>
        <div style="display: flex" v-if="this.items.LineShop">
          <a :href="this.items.LineShop" style="margin-right: 5px; margin-left: 5px;padding-top:2px">
             <v-icon class="iconify" data-icon="arcticons:line"></v-icon>
          </a>
        </div>
        <div style="display: flex" v-if="this.items.TikTokShop">
          <a :href="this.items.TikTokShop" style="margin-right: 5px; margin-left: 5px;padding-top:2px">
               <v-icon class="iconify" data-icon="cib:tiktok"></v-icon>
          </a>
        </div>
       </div>
      </v-card>
      <v-divider></v-divider>
      <!-- <menu-item icon="logout-variant" title="ออกจากร้าน" link="/MemberShop"></menu-item> -->
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderProfile from '../HeaderProfile'
import MenuItem from '../MenuItem'

export default {
  name: 'AccountMain',
  components: {
    'header-profile': HeaderProfile,
    'menu-item': MenuItem
  },
  data () {
    return {
      items: [],
      items2: [],
      isShow: false,
      shopname: [],
      member: null,
      profile: null,
      shopId: null
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    this.getOnlyShop()
    this.getBranch()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getOnlyShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/only_shop/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.items = result[0]
          this.shopname = result[0].name
        }
      }
    },
    async getBranch () {
      const result = await this.callBeTaskAPI(
        'get',
        `/master_branch/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.items2 = result
        }
      }
    }
  }
}
</script>
<style scoped>
.v-card__title{
  flex-wrap: nowrap !important;
}
p{
  margin-bottom: 0;
}
.slide-down-enter-to,
.slide-down-leave {
  transform-origin: top ;
  animation-name: menu1;
  animation-duration: 200ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  transition: max-height 2s;
}

.slide-down-enter,
.slide-down-leave-to {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;

}
.test{
  transform-origin: bottom ;
    animation-name: menu2;

  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;
    animation-timing-function: ease-in-out;

}
.animation{
  transform-origin: top ;
  animation-name: menu1;
  animation-duration: 200ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}
 @keyframes menu1 {
  0%   { opacity: 0; transform: rotateX(-50deg)}
  100% { opacity: 1; transform: rotateX(0)}
}
</style>



// WEBPACK FOOTER //
// src/components/Account/Main.vue